<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-yellow-400 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        PV
      </div>
      <h2 class="text-lg font-medium ml-4">
        {{ formPV.pvEdit ? 'แก้ไข ' + formPV.pvNo : 'สร้าง PV' }}
      </h2>
      <OverBudget />
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'reimbursementPvMyWait' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectPV()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <button
        type="button"
        class="btn box text-gray-700 disabled:opacity-50 flex items-center"
        @click.prevent="savePV(true)"
        :disabled="btnDraft.disabled"
        v-show="!btnDraft.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDraft.loading"
        />
        <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
        บันทึกแบบร่าง
      </button>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 flex items-center"
        @click.prevent="savePV(false)"
        :disabled="btnSave.disabled"
        v-show="!btnSave.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก และส่งอนุมัติ
      </button>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-5" v-if="formPV.isEdit">
            <DocumentPath
              :document-path="formPV.documentPathArray"
              :status-code="formPV.statusCode"
              :next-status-code="formPV.nextStatus"
              :approve-result="formPV.approveResultArray"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
            <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
              <div
                class="w-full h-auto flex flex-row justify-center bg-white p-4"
              >
                <img
                  v-if="companyDefault"
                  :src="companyDefault.comp_logo_url"
                  class=""
                  alt=""
                />
              </div>
            </div>
            <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
              <div class="intro-y box p-5">
                <div class="flex flex-col lg:flex-row lg:space-x-4">
                  <div class="text-theme-6">
                    ตำแหน่งเอกสาร : ผู้ขอเบิกสร้างเอกสาร
                  </div>
                  <div class="text-theme-10">
                    ผู้ดำเนินการ : {{ userInfo ? userInfo.fullname : '' }}
                  </div>
                </div>
              </div>
              <div class="intro-y box p-5 mt-5 lg:flex lg:justify-between">
                <div>
                  <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
                  <div class="font-bold">
                    {{
                      documentPathText
                        ? documentPathText.join(' -> ')
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
                <div>
                  <select
                    v-model="specialPathSelected"
                    class="form-control form-select"
                    @change="
                      onChangeDocumentPath({ target: 'select-special-path' })
                    "
                  >
                    <option :value="null"
                      >ตรวจสอบสายอนุมัติของผู้เปิดเอกสารตามวงเงิน</option
                    >
                    <option
                      v-for="spacialPath in documentSpacialPathOptions"
                      :key="spacialPath.name"
                      :value="spacialPath.name"
                      >{{ spacialPath.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="box intro-y mt-5 p-5 ">
            <div class="text-lg font-bold">ข้อมูลผู้สร้างเอกสาร</div>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-5">
              <div>
                <div class="w-full">
                  <label class="form-label"
                    >ชื่อผู้ขอเบิก<span
                      class="text-theme-6"
                      v-show="lockField.status"
                      >{{ lockField.label }}</span
                    ></label
                  >
                  <div class="preview w-full">
                    <WfSelectSingleEmployee
                      :disabled="lockField.status"
                      key="wfselect-employee"
                      v-model="formPV.employeeSelected"
                      :showBtnClear="false"
                      :options="{
                        searchMinLength: 3
                      }"
                      @change="onChangeDocumentPath"
                    ></WfSelectSingleEmployee>
                  </div>
                </div>
              </div>
              <div>
                <label class="form-label"
                  >หน่วยงาน / บริษัท<span
                    class="text-theme-6"
                    v-show="lockField.status"
                    >{{ lockField.label }}</span
                  ></label
                >
                <select
                  name=""
                  :disabled="lockField.status"
                  v-model="formPV.companySelected"
                  @change="onChangeDocumentPath({ target: 'select-company' })"
                  class="form-select w-full"
                >
                  <option
                    v-for="company in companyOptions"
                    :key="company.comp_no"
                    :value="company.comp_no"
                    >{{ company.comp_name_th }}</option
                  >
                </select>
              </div>
              <div>
                <label class="form-label">รหัสหน่วยงาน</label>
                <div class="" v-if="employeeDefault">
                  {{ employeeDefault.bu_no }} ({{ employeeDefault.bu_name }})
                </div>
              </div>
              <div>
                <label class="form-label"
                  >เบอร์ติดต่อ <span class="text-theme-6">*</span></label
                >
                <div>
                  <input
                    type="text"
                    refs="titleRef"
                    v-model="validatePV.telephone.$model"
                    class="form-control w-full"
                    :class="{
                      'border-theme-6': validatePV.telephone.$error
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="intro-y box p-5 mt-5">
            <div class="font-bold text-lg">ข้อมูลด้านบัญชี</div>
            <div class="mt-4 lg:w-1/3">
              <label class="form-label">สกุลเงิน</label>
              <div class="font-bold w-full">
                <select
                  name=""
                  v-model="formPV.currencySelected"
                  class="form-select form-control"
                >
                  <option
                    v-for="(currency, ind) in currencyOptions"
                    :key="ind"
                    :value="currency"
                    >{{ currency }}</option
                  >
                </select>
              </div>
            </div>
            <div class="mt-4 lg:w-1/3">
              <label class="form-label">ชำระโดย</label>
              <div>
                <select
                  name=""
                  v-model="formPV.cashSelected"
                  class="form-select form-control w-full"
                  @change="onChangeDocumentPath({ target: 'select-cash' })"
                >
                  <option
                    v-for="cash in cashOptions"
                    :key="cash.value"
                    :value="cash.value"
                    >{{ cash.label }}</option
                  >
                </select>
                <div
                  class="text-theme-6 mt-2"
                  v-show="formPV.cashSelected == 'p'"
                >
                  ** เงินสดย่อยต้องไม่เกิน 2,000 บาท ต่อใบสำคัญจ่าย
                </div>
              </div>
            </div>
            <div class="mt-4 lg:w-1/3" v-show="formPV.cashSelected == 'c'">
              <label for="" class="form-label ">จ่ายให้ </label>
              <div class="preview w-full">
                <WfSelectSinglePayee
                  key="wfselect-payee"
                  v-model="validatePV.payeeSelected.$model"
                  :options="{
                    ajaxLimit: 50,
                    searchMinLength: 3
                  }"
                  class="border"
                  :class="{
                    'border-theme-6': validatePV.payeeSelected.$error
                  }"
                ></WfSelectSinglePayee>
              </div>
              <div class="text-theme-6 text-sm mt-2">
                * กรณีที่มีภาษีมูลค่าเพิ่มหรือภาษีหัก ณ ที่จ่าย ให้ระบุจ่ายให้
              </div>
            </div>
          </div>

          <div class="mt-5 intro-y box p-5">
            <div class="font-bold text-lg">ข้อมูลค่าใช้จ่าย</div>
            <div class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4">
              <div class="col-span-3">
                <div class="mt-4">
                  <label class="form-label">หมายเลขใบกำกับภาษี</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="formPV.receiptNo"
                    maxlength="50"
                    placeholder="(ไม่เกิน 50 ตัวอักษร)"
                  />
                </div>
                <div class="mt-4">
                  <label class="form-label"
                    >รายละเอียด<span class="text-theme-6">*</span></label
                  >
                  <div
                    :class="{
                      'border-theme-6 border': validatePV.detail.$error
                    }"
                  >
                    <TextEditor v-model="validatePV.detail.$model" />
                  </div>
                </div>
              </div>
              <div>
                <div class="mt-4">
                  <label for="" class="form-label">เลือกเอกสารจาก Memo</label>
                  <MemoAutoComplete
                    :options="memoOptions"
                    v-model="formPV.memoSelected"
                    v-model:selectedMemo="selectedMemo"
                  />
                  <!-- <div>
                    <select
                      name=""
                      v-model="formPV.memoSelected"
                      class="form-select form-control w-full"
                    >
                      <option :value="null" key="0">-- Select Memo --</option>
                      <option
                        v-for="memo in memoOptions"
                        :key="memo.doc_no"
                        :value="memo.id"
                        >{{ memo.doc_no }} - {{ memo.title }}</option
                      >
                    </select>
                  </div> -->
                </div>
                <div class="mt-4 col-span-1">
                  <label class="form-label"
                    >ไฟล์แนบ {{ fileUploadMaxSize }} MB</label
                  >
                  <AttachFileUpload module="pv" />
                </div>
              </div>
            </div>
          </div>

          <!-- PV Item -->
          <div class="grid grid-cols-1 mt-5 box  intro-y" v-show="boxItemOpen">
            <div class="box p-5">
              <div class="text-lg font-bold mb-4">ระบุรายการเบิก</div>
              <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดค่าใช้จ่าย</div>
                  <div class="space-y-4">
                    <div class="">
                      <label for="" class="form-label "
                        >เลขที่ใบเสร็จ/ใบกำกับภาษี/วันที่ทำรายการ
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="formPVItem.receiptNo"
                        maxlength="50"
                        placeholder="(ไม่เกิน 50 ตัวอักษร)"
                      />
                    </div>
                    <div class="p-fluid p-grid">
                      <div class="p-field p-field-sm">
                        <label for="">วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี </label>
                        <Calendar
                          placeholder="2022-01-01"
                          class="mt-2"
                          inputStyle="padding:0.5rem 0.75rem;"
                          v-model="formPVItem.receiptDate"
                          dateFormat="yy-mm-dd"
                        />
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label ">Vendor </label>
                      <div class="preview w-full">
                        <WfSelectSingleVendor
                          key="wfselect-item-vendor"
                          v-model="formPVItem.vendorSelected"
                          :options="{
                            ajaxLimit: 50,
                            searchMinLength: 3
                          }"
                        ></WfSelectSingleVendor>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label ">จ่ายให้ </label>
                      <div class="preview w-full">
                        <WfSelectSinglePayee
                          key="wfselect-item-payee"
                          v-model="formPVItem.payeeSelected"
                          :options="{
                            ajaxLimit: 50,
                            searchMinLength: 3
                          }"
                        ></WfSelectSinglePayee>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >รายละเอียดค่าใช้จ่าย
                        <span class="text-theme-6">*</span></label
                      >
                      <textarea
                        name=""
                        id=""
                        rows="3"
                        v-model="validateItem.detail.$model"
                        :class="{
                          'border-theme-6': validateItem.detail.$error
                        }"
                        class="form-control"
                      ></textarea>
                    </div>
                    <div class="">
                      <label for="" class="form-label ">จำนวนเงิน(บาท)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="formPVItem.amount"
                        @keyup="calActualCost"
                        @change="calActualCost"
                      />
                    </div>
                    <div class="">
                      <label for="" class="form-label ">ภาษีมูลค่าเพิ่ม</label>
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="formPVItem.vat"
                          @keyup="calVat"
                          @change="calVat"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="formPVItem.taxVatDefault"
                          min="0"
                          max="100"
                          @keyup="calVatProcess"
                          @change="calVatProcess"
                        />
                        <button
                          class="btn"
                          :class="[
                            formPVItem.taxVatProcess
                              ? 'btn-primary'
                              : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (formPVItem.taxVatProcess = !formPVItem.taxVatProcess),
                              calVatProcess()
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >ภาษีหัก ณ ที่จ่าย</label
                      >
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="formPVItem.whTax"
                          @keyup="calTax"
                          @change="calTax"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="formPVItem.taxWhDefault"
                          min="0"
                          max="100"
                          @keyup="calTaxProcess"
                          @change="calTaxProcess"
                        />
                        <button
                          class="btn"
                          :class="[
                            formPVItem.taxWhProcess
                              ? 'btn-primary'
                              : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (formPVItem.taxWhProcess = !formPVItem.taxWhProcess),
                              calTaxProcess()
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <!-- <div class="form-check">
                      <input
                        id="isItselfTax"
                        type="checkbox"
                        class="form-check-input"
                        v-model="formPVItem.isItselfTax"
                      />
                      <label
                        for="isItselfTax"
                        class="form-check-label text-theme-6"
                        >บริษัทรับภาระเอง</label
                      >
                    </div> -->
                    <div class="">
                      <label for="" class="form-label ">ค่าใช้จ่ายจริง</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="formPVItem.actualCost"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-span-2 mt-4 lg:mt-0">
                  <!-- budget -->
                  <div class="border p-5 rounded-lg">
                    <div class="text-lg mb-4">รายละเอียดงบประมาณ</div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="mb-4">
                        <div class="mb-4">
                          <label for="" class="form-label "
                            >ค้นหางบประมาณหน่วยงาน</label
                          >
                          <div class="">
                            <a
                              class="w-full btn btn-warning"
                              href="javascript:;"
                              data-toggle="modal"
                              data-target="#modal-budget"
                            >
                              รายการงบประมาณหน่วยงาน
                            </a>
                          </div>
                        </div>
                        <div class="mb-4">
                          <label for="" class="form-label "
                            >ค้นหางบประมาณโครงการ</label
                          >
                          <div class="">
                            <a
                              class="w-full btn btn-warning"
                              :class="[
                                !isProjectBudgetEnable ? 'btn-disabled' : ''
                              ]"
                              href="javascript:;"
                              :data-toggle="
                                `${isProjectBudgetEnable ? 'modal' : ''}`
                              "
                              :data-target="
                                `${
                                  isProjectBudgetEnable ? '#modal-ledget' : ''
                                }`
                              "
                            >
                              รายการงบประมาณโครงการ
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="space-y-4">
                        <div class="">
                          <label for="" class="form-label ">ปีงบประมาณ</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.year"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">ชนิดงบประมาณ</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.bu_type"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label "
                            >ใช้งบประมาณของหน่วยงาน</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.bu_name"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">รหัส BU</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.bu_code"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Account Code</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.account_code"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Subsidiary</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.subsidiary"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Account Name</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.account_name"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label ">Subledger No</label>
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.subledger"
                          />
                        </div>
                        <div class="">
                          <label for="" class="form-label "
                            >Subledger Name</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            readonly
                            :value="formPVItem.budgetInfo.subledger_name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- btn save and cancal -->
              <div class="mt-4 flex">
                <button
                  type="button"
                  class="btn btn-primary disabled:opacity-50 mr-2 flex items-center"
                  @click.prevent="saveItem()"
                  :disabled="btnItemSave.disabled"
                  v-show="!btnItemSave.hide"
                >
                  <FileTextIcon
                    class="w-4 h-4 mr-2"
                    v-if="!btnItemSave.loading"
                  />
                  <LoadingIcon
                    icon="oval"
                    color="blue"
                    v-else
                    class="w-4 h-4 mr-2"
                  />
                  Save
                </button>
                <button class="btn ml-2" @click="clearFormItem()">
                  <Trash2Icon class="w-4 h-4 mr-2" />Cancel
                </button>
              </div>

              <!-- modal table -->
              <div
                id="modal-budget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableBudget
                        v-model="formPVItem.budgetSelected"
                        @setBudget="setBudget"
                        :company="formPV.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="modal-ledget"
                class="modal"
                tabindex="-1"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl">
                  <div class="modal-content">
                    <div class="modal-body p-10 text-center">
                      <TableSubledget
                        v-model="formPVItem.budgetSubledgerSelected"
                        @setSubledget="setBudget"
                        :company="formPV.companySelected"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- รายการเบิก -->
          <div class="grid grid-cols-1 mt-5">
            <div class="box p-5">
              <div class="grid grid-cols-1 lg:grid-cols-3 pb-4">
                <div class="flex">
                  <div class="text-lg font-bold">รายการเบิก</div>
                  <OverBudget />
                </div>
                <div
                  class="col-span-2 flex flex-col gap-2 items-end mt-2 md:mt-0"
                >
                  <div class="flex flex-row items-center">
                    <div class="mr-2">
                      <span
                        >นำข้อมูลเข้าผ่าน
                        <a
                          :href="linkImportXlsx"
                          target="_blank"
                          class="text-theme-1 font-medium"
                          ><u>Excel template</u></a
                        ></span
                      >
                    </div>
                    <div class="flex flex-row">
                      <div class="w-6 h-6 mt-2 mr-2">
                        <LoadingIcon
                          icon="puff"
                          color="green"
                          v-show="importProcess"
                        />
                      </div>
                      <input
                        type="file"
                        ref="fileImport"
                        @change="importFile"
                        class="form-control w-56"
                      />
                    </div>
                  </div>
                  <div class="flex flex-row gap-2">
                    <button
                      class="btn bg-blue-300"
                      @click="toggleBoxItemOpen()"
                      v-if="
                        formPV.statusCode == 'PV_DRAFT' ||
                          formPV.statusCode === null
                      "
                    >
                      <PlusIcon
                        class="w-4 h-4 mr-2 hidden md:block"
                      />ระบุรายการเบิก
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      type="button"
                      @click.stop="checkBudget()"
                    >
                      <CheckCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
                      ตรวจสอบงบประมาณ
                    </button>
                  </div>
                </div>
              </div>
              <!-- table -->
              <div class="overflow-x-scroll">
                <table class="table">
                  <thead>
                    <tr class="bg-gray-700 text-white">
                      <th class="whitespace-nowrap text-center" width="5%">
                        ลำดับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="65%">
                        รายละเอียด
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จำนวนเงิน
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ภาษี<br />มูลค่าเพิ่ม
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ภาษีหัก ณ<br />ที่จ่าย
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        ค่าใช้จ่ายจริง
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        จัดการ
                      </th>
                      <!-- <th class="whitespace-nowrap">ภาษีมูลค่าเพิ่ม</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center" v-if="items.length == 0">
                      <td colspan="7" class="border-b">ไม่พบรายการ</td>
                    </tr>
                    <tr
                      v-for="(item, inx) in items"
                      :key="item.pv_item_id"
                      v-else
                    >
                      <td class="border-b-2 text-center">{{ inx + 1 }}.</td>
                      <td class="border-b-2">
                        <b>เลขที่ใบเสร็จ/ใบกำกับภาษี: </b>{{ item.receipt_no
                        }}<br />
                        <b>วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี: </b
                        >{{ item.receipt_date }}<br />
                        <b>รายละเอียด: </b>
                        <p
                          v-html="
                            item.detail
                              ? item.detail.replaceAll('\n', '<br />')
                              : ''
                          "
                        ></p>
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.amount) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.vat) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.wh_tax) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.actual_cost) }}
                        <p
                          class="text-theme-6 font-bold"
                          v-show="item.isOverBudget"
                        >
                          *เกินงบประมาณ
                        </p>
                      </td>
                      <td class="text-right border-b-2">
                        <div
                          v-if="
                            formPV.statusCode == 'PV_DRAFT' ||
                              formPV.statusCode === null
                          "
                        >
                          <button
                            class="btn btn-sm"
                            :class="[
                              item.is_edit
                                ? 'btn-warning'
                                : 'btn-outline-warning'
                            ]"
                            @click="getPVItem(item.pv_item_id, inx)"
                          >
                            <EditIcon class="w-4 h-4" />
                          </button>
                          <a
                            href="javascript:;"
                            class="btn btn-sm btn-danger ml-2"
                            data-toggle="modal"
                            data-target="#delete-pv-item-modal-preview"
                            @click="setDeletePVItem(item.pv_item_id)"
                          >
                            <Trash2Icon class="w-4 h-4" />
                          </a>
                        </div>
                        <div v-else>
                          <span class="text-theme-6">ไม่สามารถแก้ไขได้</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="grid lg:grid-cols-2 gap-0 lg:gap-4">
            <!-- ประเภทของงบประมาณ -->
            <div class="mt-5">
              <TableSummaryCost :items="formPV.itemSummary" />
            </div>

            <!-- ประเภทของงบประมาณ -->
            <div class="mt-5" v-if="formPV.pvEdit">
              <TableHistory :items="formPV.historyArray" />
            </div>
          </div>

          <!-- BEGIN: Modal Content -->
          <div
            id="delete-pv-item-modal-preview"
            class="modal"
            tabindex="-1"
            data-backdrop="static"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
                    <div class="text-3xl mt-5">คุณแน่ใจ</div>
                    <div class="text-gray-600 mt-2">
                      ต้องการลบรายการนี้ ใช่ หรือ ไม่?
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
                      @click="cancelDeletePVItem()"
                    >
                      ไม่
                    </button>
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-danger w-24"
                      @click="confirmDeletePVItem()"
                    >
                      ใช่
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Modal Content -->
          <!-- BEGIN: Modal Content -->
          <ModalCancel
            module="reimbursement"
            doc-type="pv"
            :doc-id="formPV.pvID"
            redirect-complete="reimbursementPvMyWait"
          />
          <!-- END: Modal Content -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  onUnmounted,
  onMounted,
  ref,
  toRefs,
  watch
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api, apiImport } from '@/utils/api'
import { required, requiredIf } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import alert from '@/helpers/alert'
import helpers from '@/helpers'

import OverBudget from '@/components/overBudget.vue'
import WfSelectSingleEmployee from '@/components/select-single-employee/Main.vue'
import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'
import WfSelectSinglePayee from '@/components/select-single-payee/Main.vue'
import TableBudget from '@/components/table-budget/Main.vue'
import TableSubledget from '@/components/table-subledget/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFileUpload from '@/components/attach-file/Upload.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import ModalCancel from '@/components/ModalCancel.vue'
import TextEditor from '@/components/TextEditor.vue'
import MemoAutoComplete from '@/components/MemoAutoComplete.vue'
// import FileUpload from 'primevue/fileupload'
// import Dropdown from 'primevue/dropdown'
export default {
  components: {
    OverBudget,
    WfSelectSingleEmployee,
    WfSelectSingleVendor,
    WfSelectSinglePayee,
    TableBudget,
    TableSubledget,
    TableSummaryCost,
    AttachFileUpload,
    TableHistory,
    DocumentPath,
    ModalCancel,
    TextEditor,
    MemoAutoComplete
    // Dropdown
    // FileUpload
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const documentPath = computed(() => store.state.pv.documentPath)
    // const documentPathText = computed(() => store.state.pv.documentPathText)
    const btnCancel = computed(() => store.state.pv.btnCancel)
    const btnSave = computed(() => store.state.pv.btnSave)
    const btnDraft = computed(() => store.state.pv.btnDraft)
    const btnReject = computed(() => store.state.pv.btnReject)
    const btnItemSave = computed(() => store.state.pv.btnItemSave)
    const userInfo = computed(() => store.state.auth.info)

    const companyOptions = computed(() => store.state.global.company)
    const companyDefault = computed(() => store.state.global.companyDefault)
    const employeeDefault = computed(() => store.state.global.employeeDefault)
    const currencyOptions = computed(() => store.state.global.currency)
    const cashOptions = computed(() => store.state.global.cash)
    const memoOptions = computed(() => store.state.pv.memo)
    const { numberFormat, numberFormat2, dateFormat, fillBorderColor } = helpers
    const files = computed(() => store.state.pv.files)
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    const documentSpacialPathOptions = computed(
      () => store.state.global.documentSpacialPath
    )
    const linkImportXlsx = ref(process.env.VUE_APP_IMPORT_PV_XLSX)
    const isProjectBudgetEnable = ref(
      process.env.VUE_APP_PROJECT_BUDGET_ENABLE === 'true'
    )
    const documentPathText = computed(() => store.state.pv.documentPathText)
    const formPV = reactive({
      pvID: route.params.id || null,
      isEdit: route.params.id || null,
      pvEdit: route.params.id !== undefined,
      pvNo: '',
      companySelected: store.state.auth.info.comp_no,
      telephone: store.state.global.employeeDefault.telephone,
      employeeSelected: store.state.auth.info.employeeId,
      currencySelected: store.state.global.currencyDefault,
      cashSelected: store.state.global.cashDefault,
      memoSelected: null,
      receiptNo: '',
      glDate: '',
      vendorSelected: null,
      vendorName: '',
      vendorNo: '',
      payeeSelected: null,
      payeeName: '',
      payeeNo: '',
      detail: '',
      statusCode: null,
      itemSummary: [],
      historyArray: [],

      approveResultArray: [],
      documentPathArray: [],
      nextStatus: ''
    })
    const rulesPV = {
      telephone: { required },
      detail: { required },
      payeeSelected: { required: requiredIf(() => formPV.cashSelected == 'c') }
      // vendorSelected: {
      //   requiredIfFuction: requiredIf(() => {
      //     return formPV.cashSelected == 'c'
      //   })
      // }
    }

    // const rulesPV = computed(() => {
    //   const localRule = {
    //     telephone: { required },
    //     detail: { required }
    //   }
    //   // if (formPV.cashSelected == 'p') {
    //   // } else if (formPV.cashSelected == 'c') {
    //   // } else if (formPV.cashSelected == 'n') {
    //   // }
    //   if (formPV.cashSelected == 'c') {
    //     localRule.vendorSelected = { required }
    //   }
    //   return localRule
    // })

    const validatePV = useVuelidate(rulesPV, toRefs(formPV))

    const specialPathSelected = ref(null)
    // watch(specialPathSelected, newVal => {
    //   // console.log('watch special selected')
    //   store.dispatch('pv/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formPV.employeeSelected,
    //     specialPath: newVal,
    //     cashSelected: formPV.cashSelected
    //   })
    // })

    const items = ref([])
    const boxItemOpen = ref(false)
    const toggleBoxItemOpen = () => {
      clearFormItem()
      boxItemOpen.value = !boxItemOpen.value
      if (formPV.payeeSelected) {
        formPVItem.payeeSelected = formPV.payeeSelected.vendor_code
      } else {
        formPVItem.payeeSelected = null
      }
    }

    const deletePVItemID = ref(null)
    const setDeletePVItem = id => {
      deletePVItemID.value = id
    }
    const cancelDeletePVItem = () => {
      deletePVItemID.value = null
    }
    const confirmDeletePVItem = async () => {
      const resDeletePVItem = await api.delete(
        `reimbursement/pv/deleteItem/${deletePVItemID.value}`
      )
      if (resDeletePVItem.code == 200) {
        alert.success('ลบรายการ สำเร็จ')
        const newItems = await items.value.filter(item => {
          return item.pv_item_id != deletePVItemID.value
        })
        items.value = newItems
        deletePVItemID.value = null
        checkBudget()
      }
    }

    const selectedMemo = ref(null)

    const formPVItem = reactive({
      pvItemID: null,
      vendorSelected: null,
      payeeSelected: null,
      budgetSelected: null,
      isItselfTax: false,
      budgetInfo: {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      },
      budgetSubledgerSelected: null,
      bu_year: null,
      bu_name: null,
      receiptNo: null,
      receiptDate: new Date(),
      detail: null,
      amount: 0,
      vat: 0,
      whTax: 0,
      actualCost: 0,
      taxVatDefault: 7,
      taxWhDefault: 3,
      taxVatProcess: false,
      taxWhProcess: false
    })

    const rulesItem = {
      detail: { required }
      // payeeSelected: { required }
    }

    const validateItem = useVuelidate(rulesItem, toRefs(formPVItem))

    const summaryActualCost = () => {
      const a = formPVItem.amount
      const t = formPVItem.taxVatProcess
        ? (a * formPVItem.taxVatDefault) / 100
        : 0
      const wh = formPVItem.taxWhProcess
        ? (a * formPVItem.taxWhDefault) / 100
        : 0

      formPVItem.vat = formPVItem.taxVatProcess ? t : 0

      formPVItem.whTax = formPVItem.taxWhProcess ? wh : 0

      formPVItem.actualCost = numberFormat2(a - wh + t)
    }

    const calActualCost = () => {
      summaryActualCost()
    }

    const calVat = () => {
      formPVItem.actualCost = numberFormat2(
        formPVItem.amount + formPVItem.vat - formPVItem.whTax
      )
    }

    const calTax = () => {
      formPVItem.actualCost = numberFormat2(
        formPVItem.amount + formPVItem.vat - formPVItem.whTax
      )
    }

    const calVatProcess = () => {
      if (formPVItem.taxVatProcess) {
        if (formPVItem.taxVatDefault > 0 && formPVItem.taxVatDefault <= 100) {
          formPVItem.vat = (formPVItem.amount * formPVItem.taxVatDefault) / 100
        } else {
          formPVItem.vat = 0
        }
      } else {
        formPVItem.vat = 0
      }
      calVat()
    }

    const calTaxProcess = () => {
      if (formPVItem.taxWhProcess) {
        if (formPVItem.taxWhDefault > 0 && formPVItem.taxWhDefault <= 100) {
          formPVItem.whTax = (formPVItem.amount * formPVItem.taxWhDefault) / 100
        } else {
          formPVItem.whTax = 0
        }
      } else {
        formPVItem.whTax = 0
      }
      calTax()
    }

    const setBudget = val => {
      formPVItem.budgetInfo.year = val.year
      formPVItem.budgetInfo.bu_code = val.bu_code
      formPVItem.budgetInfo.bu_name = val.bu_name
      formPVItem.budgetInfo.subsidiary = val.subsidiary
      formPVItem.budgetInfo.subledger = val.subledger
      formPVItem.budgetInfo.subledger_name = val.subledger_name
      formPVItem.budgetInfo.account_code = val.account_code
      formPVItem.budgetInfo.account_name = val.account_name
      formPVItem.budgetInfo.bu_type = val.subledger
        ? 'งบประมาณโครงการ'
        : 'งบประมาณหน่วยงาน'
    }

    // const companyChange = () => {
    //   store.commit('global/setCompanyDefault', { no: formPV.companySelected })
    //   onChangeDocumentPath({
    //     target: 'select-company',
    //     value: formPV.companySelected
    //   })
    // }

    const showPayee = ref(false)
    // const showVendor = ref(false)
    watch(
      () => formPV.cashSelected,
      newVal => {
        if (!formPV.pvEdit) {
          formPV.payeeSelected = null
          formPV.payeeName = ''
          formPV.payeeNo = ''
        }
        // if (newVal != 'p') {
        //   showVendor.value = true
        // } else {
        //   showVendor.value = false
        // }
      }
    )

    watch(
      () => formPV.vendorSelected,
      newVal => {
        if (newVal) {
          // console.log('vendor newVal: ', oldVal, newVal)
          formPV.vendorName = newVal.vendor_name
          formPV.vendorNo = newVal.vendor_code
        }
      }
    )

    watch(
      () => formPV.payeeSelected,
      newVal => {
        if (newVal) {
          // console.log('vendor newVal: ', oldVal, newVal)
          formPV.payeeName = newVal.vendor_name
          formPV.payeeNo = newVal.vendor_code
        }
      }
    )

    // watch(
    //   [
    //     companyDefault,
    //     () => formPV.employeeSelected,
    //     () => formPV.cashSelected
    //   ],
    //   (newVal, oldVal) => {
    //     // if (newVal[2] == oldVal[2] || newVal[2] != 'c') {
    //     //   console.log('watch: ', oldVal, newVal, newVal[2] == oldVal[2], newVal[2] != 'c')
    //     //   specialPathSelected.value = null
    //     // }
    //     if (newVal[0] != oldVal[0]) {
    //       store.dispatch('global/loadDocumentSpacialPath', {
    //         compNo: companyDefault.value.comp_no
    //       })
    //       store.dispatch('pv/loadDocumentPath', {
    //         compNo: companyDefault.value.comp_no,
    //         employeeId: formPV.employeeSelected,
    //         specialPath: specialPathSelected.value,
    //         cashSelected: formPV.cashSelected
    //       })
    //     }

    //     if (newVal[1] != oldVal[1] || newVal[2] != oldVal[2]) {
    //       store.dispatch('pv/loadDocumentPath', {
    //         compNo: companyDefault.value.comp_no,
    //         employeeId: formPV.employeeSelected,
    //         specialPath: null,
    //         cashSelected: formPV.cashSelected
    //       })
    //     }
    //   }
    // )

    const onChangeDocumentPath = async data => {
      console.log('e: ', data, formPV.companySelected)
      if (data.target == 'select-company') {
        store.commit('global/setCompanyDefault', { no: formPV.companySelected })
      }
      if (
        data.target == 'select-single-employee' ||
        data.target == 'select-company'
      ) {
        // loading special path option
        await store.dispatch('global/loadDocumentSpacialPath', {
          compNo: companyDefault.value.comp_no
        })
        specialPathSelected.value = null
      }
      await store.dispatch('pv/loadDocumentPath', {
        // compNo: companyDefault.value.comp_no,
        compNo: formPV.companySelected,
        employeeId: formPV.employeeSelected,
        specialPath: specialPathSelected.value,
        cashSelected: formPV.cashSelected
      })

      const company = store.getters['global/companyFind'](
        formPV.companySelected
      )

      if (company) {
        await store.dispatch('global/loadCashByCompany', {
          compCode: company.comp_code
        })
      }
    }

    watch(
      () => employeeDefault.value,
      newVal => {
        if (!formPV.pvID && formPV.pvNo == '') {
          formPV.telephone = newVal.telephone
        }
      }
    )

    // const onChangeSpecialPath = () => {
    //   console.log('change: ', specialPathSelected, specialPathSelected.value)
    //   store.dispatch('pv/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formPV.employeeSelected,
    //     specialPath: specialPathSelected.value,
    //     cashSelected: formPV.cashSelected
    //   })
    // }

    const savePV = async isDraft => {
      // disabled and loading
      validatePV.value.$touch()
      if (validatePV.value.$invalid) {
        alert.error()
        return false
      }
      validatePV.value.$reset()
      if (isDraft) {
        store.commit('pv/setBtnActiveFix', { type: 'btnDraft', status: true })
      } else {
        store.commit('pv/setBtnActiveFix', { type: 'btnSave', status: true })
      }

      const dataPV = {
        is_draft: isDraft,
        username: userInfo.value.username,
        employee_id: userInfo.value.employeeId,
        pv_comp: formPV.companySelected,
        special_path: specialPathSelected.value,
        document_path: documentPath.value, // สายอนุมัติของเปิดเอกสาร

        ememo_id: null,
        ememo_title: '',

        gl_date: formPV.glDate,

        req_id: employeeDefault.value.employee_id, // '620071', // ? ผู้ขอเบิก
        req_name: employeeDefault.value.fullname_th, // 'ธนัชกฤศ เกตุนะ', // ? ชื่อผู้ขอเบิก
        req_detail: fillBorderColor(formPV.detail), // ?
        // payee_no: employeeDefault.value.employee_id, // '620071', // ?
        // payee_name: employeeDefault.value.fullname_th, // 'ธนัชกฤศ เกตุนะ', // ?

        owner_id: userInfo.value.employeeId, // ผู้ขอเบิก
        owner_name: userInfo.value.fullname, // ชื่อผู้ขอเบิก
        bu_no: employeeDefault.value.bu_no, // รหัสหน่วยงาน มาจาก req_id
        bu_name: employeeDefault.value.bu_name, // ชื่อหน่วยงาน มาจาก req_id
        telephone: formPV.telephone, // เบอร์ติดต่อ
        po_no: formPV.receiptNo, // ?
        petty_cash: formPV.cashSelected, // ชำระโดย
        file_attach: await store.getters['pv/getFileAttach'], // เอกสารแนบ
        currency: formPV.currencySelected, // สกุลเงิน
        // vendor_no: null,
        // vendor_name: null,
        payee_no: null,
        payee_name: null
      }

      // if (formPV.memoSelected) {
      //   const memo = memoOptions.value.find(item => {
      //     return item.id == formPV.memoSelected
      //   })
      //   if (memo) {
      //     dataPV.ememo_id = memo.id
      //     dataPV.ememo_title = `${memo.doc_no_full} - ${memo.title}`
      //   }
      // }

      if (selectedMemo.value) {
        dataPV.ememo_id = selectedMemo.value.id
        dataPV.ememo_title = `${selectedMemo.value.doc_no_full} - ${selectedMemo.value.title}`
      }

      // if (formPV.vendorSelected && formPV.cashSelected == 'c') {
      //   dataPV.vendor_no = formPV.vendorNo
      //   dataPV.vendor_name = formPV.vendorName
      // } else {
      //   dataPV.vendor_no = null
      //   dataPV.vendor_name = null
      // }

      if (formPV.payeeSelected && formPV.cashSelected == 'c') {
        dataPV.payee_no = formPV.payeeNo
        dataPV.payee_name = formPV.payeeName
      } else {
        dataPV.payee_no = null
        dataPV.payee_name = null
      }

      // console.log('dataPV: ', isDraft, dataPV)
      if (!formPV.pvEdit) {
        await api
          .post('/reimbursement/pv/insert', dataPV)
          .then(res => {
            if (res.code == 200) {
              formPV.pvID = res.data.pv_id
              formPV.pvEdit = true
              alertBudget(false, res.data.is_over_budget)
              store.commit('pv/setBtn', { type: 'btnCancel', value: 'hide' })
              alert.success()
            } else {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('pv/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }

            if (isDraft) {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              router.push({
                name: 'reimbursementPvFormDetail',
                params: { id: res.data.pv_id }
              })
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      } else {
        await api
          .put(`/reimbursement/pv/update/${formPV.pvID}`, dataPV)
          .then(res => {
            if (res.code == 200) {
              alertBudget(false, res.data.is_over_budget)
              alert.success()
            } else {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
              store.commit('pv/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
              if (res.validator) {
                alert.validatorShow(res.validator)
              } else {
                alert.error(res.message)
              }
              return
            }
            if (isDraft) {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              router.push({
                name: 'reimbursementPvFormDetail',
                params: { id: formPV.pvID }
              })
            }
          })
          .catch(e => {
            alert.error(e.message)
            if (isDraft) {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnDraft',
                status: false
              })
            } else {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnSave',
                status: false
              })
            }
          })
      }
    }

    const clearFormItem = () => {
      validateItem.value.$reset()
      boxItemOpen.value = false
      if (formPVItem.pvItemID !== null) {
        for (const i in items.value) {
          items.value[i].is_edit = false
        }
      }
      formPVItem.pvItemID = null
      formPVItem.vendorSelected = null
      formPVItem.payeeSelected = null
      formPVItem.budgetSelected = null
      formPVItem.isItselfTax = false

      formPVItem.budgetInfo = {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      }
      formPVItem.budgetSubledgerSelected = null
      formPVItem.bu_year = null
      formPVItem.bu_name = null
      formPVItem.receiptNo = null
      formPVItem.receiptDate = new Date()
      formPVItem.detail = null
      formPVItem.amount = 0
      formPVItem.vat = 0
      formPVItem.whTax = 0
      formPVItem.actualCost = 0
      formPVItem.taxVatDefault = 7
      formPVItem.taxWhDefault = 3
      formPVItem.taxVatProcess = false
      formPVItem.taxWhProcess = false
    }

    const saveItem = async () => {
      validateItem.value.$touch()
      if (!validateItem.value.$invalid) {
        store.commit('pv/setBtnActiveFix', {
          type: 'btnItemSave',
          status: true
        })
        if (formPV.pvID === null) {
          await savePV(true)
        }
        const dataItem = {
          pv_id: formPV.pvID,
          receipt_no: formPVItem.receiptNo,
          receipt_date: dateFormat(formPVItem.receiptDate),
          vendor_no: formPVItem.vendorSelected
            ? formPVItem.vendorSelected.vendor_code
            : null,
          vendor_name: formPVItem.vendorSelected
            ? formPVItem.vendorSelected.vendor_name
            : null,
          // vendor_no:
          //   formPVItem.vendorSelected && formPV.cashSelected != 'p'
          //     ? formPVItem.vendorSelected.vendor_code
          //     : null,
          // vendor_name:
          //   formPVItem.vendorSelected && formPV.cashSelected != 'p'
          //     ? formPVItem.vendorSelected.vendor_name
          //     : null,
          payee_no: formPVItem.payeeSelected
            ? formPVItem.payeeSelected.vendor_code
            : null,
          payee_name: formPVItem.payeeSelected
            ? formPVItem.payeeSelected.vendor_name
            : null,
          detail: formPVItem.detail,
          amount: formPVItem.amount,
          vat_rate: formPVItem.taxVatDefault,
          wh_tax_rate: formPVItem.taxWhDefault,
          vat: formPVItem.vat,
          wh_tax: formPVItem.whTax,
          is_itself_tax: formPVItem.isItselfTax ? 1 : 0,
          actual_cost: formPVItem.actualCost,

          budget_year: formPVItem.budgetInfo.year,
          budget_type: formPVItem.budgetInfo.subledger ? null : 'bu',
          budget_bu_code: formPVItem.budgetInfo.bu_code,
          budget_bu_name: formPVItem.budgetInfo.bu_name,
          budget_code: formPVItem.budgetInfo.account_code,
          budget_name: formPVItem.budgetInfo.account_name,

          budget_subsidiary:
            formPVItem.budgetInfo.subledger !== ''
              ? formPVItem.budgetInfo.subsidiary
              : null,
          budget_subledger:
            formPVItem.budgetInfo.subledger !== ''
              ? formPVItem.budgetInfo.subledger
              : null,
          budget_subledger_name:
            formPVItem.budgetInfo.subledger !== ''
              ? formPVItem.budgetInfo.subledger_name
              : null,

          invoice_no: '',
          invoice_date: '',
          history: null
        }
        if (formPVItem.pvItemID === null) {
          await api
            .post('/reimbursement/pv/insertItem', dataItem)
            .then(async res => {
              if (res.code == 200) {
                alert.success('เพิ่มข้อมูล')
                items.value.push(res.data)
                clearFormItem()
                await reloadPV()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .then(() => checkBudget())
            .catch(e => {
              alert.error(e.message)
              store.commit('pv/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        } else {
          await api
            .put(
              `/reimbursement/pv/updateItem/${formPVItem.pvItemID}`,
              dataItem
            )
            .then(async res => {
              if (res.code == 200) {
                alert.success('อัพเดทข้อมูล')
                clearFormItem()
                await reloadPV()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .then(() => checkBudget())
            .catch(e => {
              store.commit('pv/setBtnActiveFix', {
                type: 'btnItemSave',
                status: false
              })
            })
        }
        // reloadPV()
        store.commit('pv/setBtnActiveFix', {
          type: 'btnItemSave',
          status: false
        })

        return dataItem
      } else {
        alert.error()
      }
    }

    const alertBudget = (isLoading, isOver) => {
      if (isLoading) {
        store.commit('global/setOverBudget', {
          message: 'กำลังตรวจสอบ',
          isOver: true,
          show: true
        })
      } else {
        store.commit('global/setOverBudget', {
          message: isOver == 1 ? 'เกินงบประมาณ' : 'อยู่ในงบประมาณ',
          isOver: isOver == 1,
          show: true
        })
      }
    }

    const setItems = data => {
      items.value = data.map(item => {
        return {
          receipt_no: item.receipt_no,
          receipt_date: item.receipt_date,
          detail: item.detail,
          actual_cost: item.actual_cost,
          amount: item.amount,
          vat: item.vat,
          wh_tax: item.wh_tax,
          pv_item_id: item.pv_item_id,
          is_edit: false,
          isOverBudget: false
        }
      })
    }

    const reloadPV = async () => {
      if (formPV.pvID) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/pv/getByPvId/${formPV.pvID}`
          )
          .then(res => {
            if (res.code == 200) {
              setItems(res.data.items)
              formPV.itemSummary = res.data.itemSummary
            }
          })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page pv form')
      store.commit('global/setLoadingPage', true)
      store.commit('pv/initBtn')
    })

    const lockField = reactive({
      status: false,
      label: '(ไม่สามารถแก้ไขได้)'
    })

    const getPV = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/pv/getByPvId/${route.params.id}`
          )
          .then(res => {
            if (res.code == 200) {
              formPV.companySelected = res.data.pv_comp
              formPV.employeeSelected = res.data.req_id
              formPV.currencySelected = res.data.currency
              formPV.cashSelected = res.data.petty_cash
              formPV.telephone = res.data.telephone
              formPV.detail = res.data.req_detail
              formPV.receiptNo = res.data.po_no
              formPV.payeeSelected = res.data.payee_no
              formPV.vendorName = res.data.vendor_name
              specialPathSelected.value = res.data.special_path
              formPV.itemSummary = res.data.itemSummary
              formPV.statusCode = res.data.status_code
              formPV.pvNo = res.data.doc_no_full
              formPV.historyArray = res.data.history_array

              formPV.approveResultArray = res.data.approve_result_array
              formPV.documentPathArray = res.data.document_path_array
              formPV.nextStatus = res.data.next_status

              // update 2022-04-21
              // if (res.data.doc_no_full != '' && res.data.flag_edit != 2) {
              if (res.data.doc_no_full != '') {
                lockField.status = true
              }

              // console.log('load get pv')
              store.commit(
                'pv/setDocumentPathText',
                res.data.document_path_text_array
              )
              store.commit('pv/setDocumentPath', res.data.document_path_array)
              for (const i in res.data.file_attach_array) {
                store.commit('pv/setFile', res.data.file_attach_array[i])
              }

              store.dispatch('global/loadDocumentSpacialPath', {
                compNo: res.data.pv_comp
              })

              if (res.data.ememo_id) {
                formPV.memoSelected = res.data.ememo_id
              }
              // formPV.memoSelected = 977

              if (items.value.length > 0) {
                alertBudget(false, res.data.is_over_budget)
              }

              setItems(res.data.items)

              store.commit('pv/setBtn', { type: 'btnCancel', value: 'hide' })

              if (res.data.status_code != 'PV_DRAFT') {
                store.commit('pv/setBtn', { type: 'btnDraft', value: 'hide' })
                if (res.data.flag_edit === null || res.data.flag_edit === 0) {
                  store.commit('pv/setBtn', { type: 'btnSave', value: 'hide' })
                }
              }

              if (
                res.data.status_code == 'PV_DRAFT' &&
                res.data.flag_edit != 0
              ) {
                store.commit('pv/setBtn', { type: 'btnDraft', value: 'hide' })
              }

              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('pv/setBtn', { type: 'btnReject', value: 'hide' })
              }

              // if (res.data.flat_edit == 1) {
              //   store.commit('pv/setBtn', { type: 'btnSave', value: 'hide' })
              // }
            }
            // console.log('res edit: ', res)
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
      // await store.commit('global/setLoadingPage', false)
      return true
    }

    const getPVItem = async (pvItemID, index) => {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      items.value[index].is_edit = true
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/reimbursement/pv/getItemById/${pvItemID}`
        )
        .then(res => {
          if (res.code == 200) {
            boxItemOpen.value = true
            formPVItem.pvItemID = res.data.pv_item_id
            formPVItem.receiptNo = res.data.receipt_no
            formPVItem.receiptDate = res.data.receipt_date
            formPVItem.vendorSelected =
              res.data.vendor_no != null ? res.data.vendor_no.toString() : null
            formPVItem.payeeSelected = res.data.payee_no
            formPVItem.detail = res.data.detail
            formPVItem.amount = res.data.amount
            formPVItem.taxVatDefault = res.data.vat_rate
            formPVItem.taxWhDefault = res.data.wh_tax_rate
            formPVItem.vat = parseFloat(numberFormat2(res.data.vat))
            formPVItem.whTax = parseFloat(numberFormat2(res.data.wh_tax))
            formPVItem.actualCost = numberFormat2(res.data.actual_cost)
            formPVItem.isItselfTax = res.data.is_itself_tax == 1
            formPVItem.taxVatProcess = res.data.vat > 0
            formPVItem.taxWhProcess = res.data.wh_tax > 0
            formPVItem.budgetInfo = {
              year: res.data.budget_year,
              bu_name: res.data.budget_bu_name,
              bu_code: res.data.budget_bu_code,
              bu_type: res.data.budget_subledger
                ? 'งบประมาณโครงการ'
                : 'งบประมาณหน่วยงาน',
              subledger: res.data.budget_subledger,
              subsidiary: res.data.budget_subsidiary,
              account_code: res.data.budget_code,
              account_name: res.data.budget_name,
              subledger_name: res.data.budget_subledger_name
            }
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
      return true
    }

    const checkBudget = async () => {
      if (!formPV.pvID || items.value.length == 0) {
        store.commit('global/resetOverBudget')
        return
      }
      alertBudget(true, 0)
      await api
        .get(`/reimbursement/pv/checkOverBudgetByDocId/${formPV.pvID}`)
        .then(res => {
          if (res.code == 200) {
            alertBudget(false, res.data.is_over_budget)
            for (const i in items.value) {
              items.value[i].isOverBudget = res.data.is_over_by.includes(
                items.value[i].pv_item_id
              )
            }
            if (res.data.is_over_budget) {
              alert.error('เกินงบประมาณ')
            }
          } else {
            alertBudget(true, 0)
            alert.error(res.message)
          }
          return res.data
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const rejectPV = async () => {
      store.commit('pv/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/pv/editBeforeApprove/${formPV.pvID}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('pv/setBtn', { type: 'btnDraft', value: 'hide' })
            store.commit('pv/setBtn', { type: 'btnSave', value: 'hide' })
            store.commit('pv/setBtn', { type: 'btnReject', value: 'hide' })
            store.commit('pv/setBtnActive', { type: 'btnReject' })
          } else {
            alert.error(res.message)
          }
        })
    }
    const importProcess = ref(false)
    const importFile = async event => {
      if (formPV.pvID === null) {
        await savePV(true)
      }
      if (event.target.files[0]) {
        if (event.target.files[0].name.length <= 200) {
          if (formPV.pvID !== null) {
            importProcess.value = true
            const formData = new FormData()
            formData.append('file', event.target.files[0])
            formData.append('doc_type', 'pv')
            formData.append('doc_id', formPV.pvID)
            await apiImport
              .post('/import/docItem', formData)
              .then(res => {
                // console.log('res: ', res, res.data.insert_fail)
                importProcess.value = false
                if (res.data.insert_fail > 0) {
                  const errorMsg = res.data.insert_fail_data.map(item => {
                    return `บรรทัดที่ ${item.line_fail}. ${item.message}`
                  })
                  alert.error(errorMsg.join('<br>') + '<br>กรุณาตรวจสอบ')
                  event.target.value = null
                } else {
                  alert.success()
                  reloadPV()
                }
              })
              .catch(e => {
                alert.error(e.message)
                importProcess.value = false
              })
          } else {
            event.target.value = null
          }
        } else {
          alert.error('ชื่อไฟล์ยาวเกิน 200 ตัวอักษร')
        }
      }
    }

    onMounted(async () => {
      console.log('mounted page pv form')
      await store.dispatch('global/loadCompany')
      store.dispatch('global/loadCurrency')
      // store.dispatch('global/loadCash')
      // store.dispatch('global/loadCashByCompany', {
      //   compCode: store.state.auth.info.comp_code
      // })
      store.dispatch('global/loadFileUploadMaxSize')
      store.commit('global/resetOverBudget')
      if (!formPV.pvEdit) {
        // case news
        await store.dispatch('global/loadDocumentSpacialPath', {
          compNo: store.state.auth.info.comp_no
        })
      }
      store.commit('pv/setBtn', { type: 'btnItemSave', value: 'hide' })
      store.commit('pv/setBtn', { type: 'btnSave', value: 'hide' })
      store.commit('pv/setBtn', { type: 'btnDraft', value: 'hide' })
      // console.log('mounted: ', companyDefault)

      await getPV()
      store.dispatch('pv/loadMemo', { ememoId: formPV.memoSelected })
      store.commit('global/setCompanyDefault', { no: formPV.companySelected })
      await onChangeDocumentPath({ target: 'mounted' })
      await store.commit('global/setLoadingPage', false)
      if (formPV.pvEdit) {
        await checkBudget()
      }
    })

    return {
      loadingPage,
      btnSave,
      btnCancel,
      btnDraft,
      btnReject,
      btnItemSave,
      boxItemOpen,
      toggleBoxItemOpen,
      companyDefault,
      companyOptions,
      clearFormItem,
      currencyOptions,
      cashOptions,
      documentSpacialPathOptions,
      specialPathSelected,
      memoOptions,
      fileUploadMaxSize,
      formPV,
      formPVItem,
      getPVItem,
      files,
      items,
      // companyChange,
      userInfo,
      savePV,
      saveItem,
      setBudget,
      validateItem,
      setDeletePVItem,
      confirmDeletePVItem,
      cancelDeletePVItem,
      deletePVItemID,
      checkBudget,
      rejectPV,
      numberFormat,
      dateFormat,
      // showVendor,
      showPayee,
      documentPathText,
      calActualCost,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      lockField,
      validatePV,
      onChangeDocumentPath,
      importFile,
      importProcess,
      employeeDefault,
      selectedMemo,
      linkImportXlsx,
      isProjectBudgetEnable
    }
  }
}
</script>

<style scoped>
.vue-select {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e2e8f0;
  border-style: solid;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
